export const rowTitleStyles = {
  fontWeight: 600,
  borderBottom: "none",
}

export const rowValueStyles = {
  fontWeight: 500,
  borderBottom: "none",
  fontSize: "1rem",
  textAlign: "end",
  color: "text.secondary"
}